import { useLanguage } from '../../contexts/language';

import { QuestionnaireRow } from '../questionnaire-row';

import styles from './style.module.css';

// The questionnaires assigned now, one row each with its state and the way
// in, the same ones the Tests section lists.
export function OpenQuestionnaires({ assignments }) {
  const { text } = useLanguage();

  let rows = <p className={ styles.empty }>{ text.nothingAssigned }</p>;

  if (assignments.length > 0) {
    rows = assignments.map(function(assignment) {
      return <QuestionnaireRow key={ assignment.id } assignment={ assignment }/>;
    });
  }

  return (
    <section className={ styles.card } aria-labelledby='today-questionnaires'>
      <h2 id='today-questionnaires' className={ styles.title }>{ text.questionnaires }</h2>

      { rows }
    </section>
  );
}
